"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrandingHexColorCodeProperty = exports.brandingHexColorCodePropertyDefinition = void 0;
const BRANDING_HEX_COLOR_CODE_PATTERN = '^#(?:[0-9a-fA-F]{3}){1,2}$';
exports.brandingHexColorCodePropertyDefinition = {
    name: 'branding-hex-color-code',
    type: 'text',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'pattern',
            argument: BRANDING_HEX_COLOR_CODE_PATTERN,
        },
    ],
    multiple: false,
    view: {
        label: 'Branding color',
        hint: 'Branding color code of this edition in HEX format - e.g. #FFFFFF.',
        style: '',
    },
};
const isBrandingHexColorCodeProperty = (prop) => {
    return prop.name === exports.brandingHexColorCodePropertyDefinition.name;
};
exports.isBrandingHexColorCodeProperty = isBrandingHexColorCodeProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJhbmRpbmctaGV4LWNvbG9yLWNvZGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9icmFuZGluZy1oZXgtY29sb3ItY29kZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFNLCtCQUErQixHQUFHLDRCQUE0QixDQUFBO0FBRXZELFFBQUEsc0NBQXNDLEdBQUc7SUFDcEQsSUFBSSxFQUFFLHlCQUF5QjtJQUMvQixJQUFJLEVBQUUsTUFBTTtJQUNaLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFNBQVM7WUFDZixRQUFRLEVBQUUsK0JBQStCO1NBQzFDO0tBQ0Y7SUFDRCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxnQkFBZ0I7UUFDdkIsSUFBSSxFQUFFLG1FQUFtRTtRQUN6RSxLQUFLLEVBQUUsRUFBRTtLQUNWO0NBQzhCLENBQUE7QUFJMUIsTUFBTSw4QkFBOEIsR0FBRyxDQUFDLElBQWtCLEVBQXdDLEVBQUU7SUFDekcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDhDQUFzQyxDQUFDLElBQUksQ0FBQTtBQUNsRSxDQUFDLENBQUE7QUFGWSxRQUFBLDhCQUE4QixrQ0FFMUMifQ==